import React, { forwardRef } from "react";
import { useSelector } from "react-redux";
import { Img, Wrapper, StyledBlueAnchorTag } from "../../constants/common/StyledGlobalConstants";
import LeftChevron from "../../assets/icons/LeftChevron.svg";
import RightChevron from "../../assets/icons/chevron_right.svg";
import styled from "styled-components";
import propTypes from "prop-types";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

const CustomBreadcrumbsWrapper = styled.div`
  li > div {
    display: none;
  }
`;
const BreadcrumbLink = styled(StyledBlueAnchorTag)`
  text-decoration-line: none;
`;

const RedesignedBreadCrumbs = forwardRef(({ Items, handleBack }, ref) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleBack();
    }
  };

  const handleClick = (event) => {
    event.preventDefault();
    handleBack();
  };

  return (
    <>
      {windowSize.width < TABLET ? (
        <Wrapper display="flex" alignItems="center" gap="0.5rem">
          <Img src={LeftChevron} aria-label="left chevron" aria-hidden="true" alt="leftChevron"></Img>
          <BreadcrumbLink id={Items[0].id} onClick={handleClick} aria-label={Items[0].name} tabIndex={0} href="#" onKeyDown={handleKeyDown} ref={ref}>
            {Items[0].name}
          </BreadcrumbLink>
        </Wrapper>
      ) : (
        <CustomBreadcrumbsWrapper aria-label="Breadcrumbs">
          <BreadcrumbLink id={Items[0].id} onClick={handleClick} onKeyDown={handleKeyDown} tabIndex={0} href="#" aria-label={Items[0].name} ref={ref}>
            {Items[0].name}
          </BreadcrumbLink>
          <Img src={RightChevron} aria-label="left chevron" aria-hidden="true" marginLeft="10px" marginRight="10px"></Img>
          <span
            style={{
              fontSize: "0.875rem",
              fontWeight: "bold",
              fontFamily: "neue-haas-grotesk-text",
            }}
            aria-label={Items[1].name}
          >
            {Items[1].name}
          </span>
        </CustomBreadcrumbsWrapper>
      )}
    </>
  );
});

RedesignedBreadCrumbs.propTypes = {
  Items: propTypes.array.isRequired,
  handleBack: propTypes.func.isRequired,
};

export default RedesignedBreadCrumbs;
